// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn::after {
  content: none !important;
  display: none !important;
}

.certificate-form {
  display: grid;
  gap: 4px 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  min-width: min(620px, 80vw);
  padding-top: 8px;
}

.certificate-form__wide {
  grid-column: 1/-1;
}

.current-attachment {
  align-items: center;
  color: var(--dark);
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  font-size: 0.82rem;
}

.current-attachment mat-icon {
  color: var(--primary);
}

.current-attachment > span:last-child {
  color: var(--secondary);
  flex-basis: 100%;
  padding-left: 1.9rem;
}

.file-picker {
  align-items: center;
  background: var(--light);
  border: 2px dashed #9aa8b6;
  border-radius: 4px;
  box-sizing: border-box;
  color: var(--dark);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  justify-content: center;
  min-height: 170px;
  padding: 1.25rem;
  position: relative;
  text-align: center;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.file-picker:hover,
.file-picker--drag-over {
  background: color-mix(in srgb, var(--primary) 7%, white);
  border-color: var(--primary);
}

.file-picker--drag-over {
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary) 20%, transparent);
}

.file-picker--selected {
  border-style: solid;
}

.file-picker--disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.file-picker__input {
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

.file-picker__input:focus-visible + .file-picker__icon {
  outline: 2px solid var(--primary);
  outline-offset: 3px;
}

.file-picker__icon {
  color: var(--primary);
  font-size: 2rem;
  height: 2rem;
  width: 2rem;
}

.file-picker > strong {
  font-size: 0.88rem;
  overflow-wrap: anywhere;
}

.file-picker__hint {
  color: var(--secondary);
  font-size: 0.78rem;
}

.file-picker__action {
  background: #fff;
  border: 1px solid var(--primary);
  border-radius: 0.25rem;
  color: var(--primary) !important;
  font-size: 0.875rem !important;
  font-weight: 600;
  margin-top: 0.2rem;
  padding: 0.4rem 0.75rem;
}

.certificate-form input[type=date]::-webkit-calendar-picker-indicator {
  display: none;
}

.certificate-dialog__cancel,
.certificate-dialog__cancel:hover,
.certificate-dialog__cancel:focus,
.certificate-dialog__cancel:focus-visible {
  background: #fff !important;
  border: 1px solid var(--primary) !important;
  color: var(--primary) !important;
}

.certificate-dialog__cancel:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--primary) 35%, transparent);
  outline-offset: 2px;
}

.certificate-dialog__save,
.certificate-dialog__save:hover,
.certificate-dialog__save:focus,
.certificate-dialog__save:focus-visible {
  background: var(--primary) !important;
  border: 1px solid var(--primary) !important;
  color: #fff !important;
}

.certificate-dialog__save:hover,
.certificate-dialog__save:focus,
.certificate-dialog__save:focus-visible {
  background: #0069d9 !important;
  border-color: #0069d9 !important;
}

.certificate-dialog__save:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--primary) 35%, transparent);
  outline-offset: 2px;
}

.form-error {
  background: color-mix(in srgb, var(--danger) 10%, white);
  border-left: 4px solid var(--danger);
  color: var(--danger);
  padding: 12px;
}

:host ::ng-deep .mat-mdc-form-field {
  --mdc-outlined-text-field-focus-label-text-color: var(--primary);
  --mdc-outlined-text-field-focus-outline-color: var(--primary);
}

@media (max-width: 700px) {
  .certificate-form {
    grid-template-columns: 1fr;
    min-width: 0;
  }
  .certificate-form__wide {
    grid-column: auto;
  }
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/yearly-calibration-certificates/yearly-calibration-certificate-form-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;AACF;;AAEA;EACE,aAAA;EACA,aAAA;EACA,gDAAA;EACA,2BAAA;EACA,gBAAA;AACF;;AAEA;EAA0B,iBAAA;AAE1B;;AADA;EAAsB,mBAAA;EAAqB,kBAAA;EAAoB,aAAA;EAAe,eAAA;EAAiB,YAAA;EAAa,kBAAA;AAU5G;;AATA;EAA+B,qBAAA;AAa/B;;AAZA;EAAwC,uBAAA;EAAyB,gBAAA;EAAkB,oBAAA;AAkBnF;;AAhBA;EACE,mBAAA;EACA,wBAAA;EACA,0BAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uFAAA;AAmBF;;AAjBA;;EAEE,wDAAA;EACA,4BAAA;AAoBF;;AAlBA;EACE,yEAAA;AAqBF;;AAnBA;EAAyB,mBAAA;AAuBzB;;AAtBA;EAAyB,mBAAA;EAAqB,aAAA;AA2B9C;;AA1BA;EACE,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AA6BF;;AA3BA;EACE,iCAAA;EACA,mBAAA;AA8BF;;AA5BA;EAAqB,qBAAA;EAAuB,eAAA;EAAiB,YAAA;EAAc,WAAA;AAmC3E;;AAlCA;EAAwB,kBAAA;EAAmB,uBAAA;AAuC3C;;AAtCA;EAAqB,uBAAA;EAAyB,kBAAA;AA2C9C;;AA1CA;EACE,gBAAA;EACA,gCAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AA6CF;;AA1CA;EAA0E,aAAA;AA8C1E;;AA5CA;;;;EAIE,2BAAA;EACA,2CAAA;EACA,gCAAA;AA+CF;;AA7CA;EACE,sEAAA;EACA,mBAAA;AAgDF;;AA9CA;;;;EAIE,qCAAA;EACA,2CAAA;EACA,sBAAA;AAiDF;;AA/CA;;;EAGE,8BAAA;EACA,gCAAA;AAkDF;;AAhDA;EACE,sEAAA;EACA,mBAAA;AAmDF;;AAhDA;EACE,wDAAA;EACA,oCAAA;EACA,oBAAA;EACA,aAAA;AAmDF;;AAhDA;EACE,gEAAA;EACA,6DAAA;AAmDF;;AAhDA;EACE;IAAoB,0BAAA;IAA4B,YAAA;EAqDhD;EApDA;IAA0B,iBAAA;EAuD1B;AACF","sourcesContent":[".btn::after {\n  content: none !important;\n  display: none !important;\n}\n\n.certificate-form {\n  display: grid;\n  gap: 4px 16px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  min-width: min(620px, 80vw);\n  padding-top: 8px;\n}\n\n.certificate-form__wide { grid-column: 1 / -1; }\n.current-attachment { align-items: center; color: var(--dark); display: flex; flex-wrap: wrap; gap: .45rem; font-size: .82rem; }\n.current-attachment mat-icon { color: var(--primary); }\n.current-attachment > span:last-child { color: var(--secondary); flex-basis: 100%; padding-left: 1.9rem; }\n\n.file-picker {\n  align-items: center;\n  background: var(--light);\n  border: 2px dashed #9aa8b6;\n  border-radius: 4px;\n  box-sizing: border-box;\n  color: var(--dark);\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: .45rem;\n  justify-content: center;\n  min-height: 170px;\n  padding: 1.25rem;\n  position: relative;\n  text-align: center;\n  transition: background-color .15s ease, border-color .15s ease, box-shadow .15s ease;\n}\n.file-picker:hover,\n.file-picker--drag-over {\n  background: color-mix(in srgb, var(--primary) 7%, white);\n  border-color: var(--primary);\n}\n.file-picker--drag-over {\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary) 20%, transparent);\n}\n.file-picker--selected { border-style: solid; }\n.file-picker--disabled { cursor: not-allowed; opacity: .65; }\n.file-picker__input {\n  clip: rect(0, 0, 0, 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n.file-picker__input:focus-visible + .file-picker__icon {\n  outline: 2px solid var(--primary);\n  outline-offset: 3px;\n}\n.file-picker__icon { color: var(--primary); font-size: 2rem; height: 2rem; width: 2rem; }\n.file-picker > strong { font-size: .88rem; overflow-wrap: anywhere; }\n.file-picker__hint { color: var(--secondary); font-size: .78rem; }\n.file-picker__action {\n  background: #fff;\n  border: 1px solid var(--primary);\n  border-radius: .25rem;\n  color: var(--primary) !important;\n  font-size: .875rem !important;\n  font-weight: 600;\n  margin-top: .2rem;\n  padding: .4rem .75rem;\n}\n\n.certificate-form input[type=\"date\"]::-webkit-calendar-picker-indicator { display: none; }\n\n.certificate-dialog__cancel,\n.certificate-dialog__cancel:hover,\n.certificate-dialog__cancel:focus,\n.certificate-dialog__cancel:focus-visible {\n  background: #fff !important;\n  border: 1px solid var(--primary) !important;\n  color: var(--primary) !important;\n}\n.certificate-dialog__cancel:focus-visible {\n  outline: 2px solid color-mix(in srgb, var(--primary) 35%, transparent);\n  outline-offset: 2px;\n}\n.certificate-dialog__save,\n.certificate-dialog__save:hover,\n.certificate-dialog__save:focus,\n.certificate-dialog__save:focus-visible {\n  background: var(--primary) !important;\n  border: 1px solid var(--primary) !important;\n  color: #fff !important;\n}\n.certificate-dialog__save:hover,\n.certificate-dialog__save:focus,\n.certificate-dialog__save:focus-visible {\n  background: #0069d9 !important;\n  border-color: #0069d9 !important;\n}\n.certificate-dialog__save:focus-visible {\n  outline: 2px solid color-mix(in srgb, var(--primary) 35%, transparent);\n  outline-offset: 2px;\n}\n\n.form-error {\n  background: color-mix(in srgb, var(--danger) 10%, white);\n  border-left: 4px solid var(--danger);\n  color: var(--danger);\n  padding: 12px;\n}\n\n:host ::ng-deep .mat-mdc-form-field {\n  --mdc-outlined-text-field-focus-label-text-color: var(--primary);\n  --mdc-outlined-text-field-focus-outline-color: var(--primary);\n}\n\n@media (max-width: 700px) {\n  .certificate-form { grid-template-columns: 1fr; min-width: 0; }\n  .certificate-form__wide { grid-column: auto; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
